//@flow
import * as React from 'react';
import { useMutation } from '../hooks/useMutation';

type Props = {
  mutation: String
};

export const Mutation: React.FC<Props> = props => {
  const { mutate } = useMutation(props.mutation);

  return props.children(mutate);
};
